(function () {
    const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    let zoomFrame = null;
    let zoomEventsBound = false;

    function updateImageZoom() {
        zoomFrame = null;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        document.querySelectorAll("[data-collection-slider][data-imgzoom] img").forEach(function (image) {
            if (reducedMotionQuery.matches) {
                image.style.setProperty("--collection-slider-image-scale", "1");
                return;
            }

            const rect = image.getBoundingClientRect();
            const animationDistance = viewportHeight + rect.height * 0.5;
            const progress = Math.min(1, Math.max(0, (viewportHeight - rect.top) / animationDistance));
            const scale = 1.2 - progress * 0.2;
            image.style.setProperty("--collection-slider-image-scale", scale.toFixed(4));
        });
    }

    function requestImageZoomUpdate() {
        if (zoomFrame) return;
        zoomFrame = window.requestAnimationFrame(updateImageZoom);
    }

    function revealCollectionSlider(section) {
        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
                section.classList.add("section-collection-slider--ready");
            });
        });
    }

    function ensureEnoughLoopSlides(slider) {
        const wrapper = slider.querySelector(":scope > .swiper-wrapper");
        const slides = wrapper ? Array.from(wrapper.children).filter(function (slide) {
            return slide.classList.contains("collection-slider__slide") && !slide.hasAttribute("data-collection-slider-clone");
        }) : [];

        if (!wrapper || slides.length < 2) {
            return slides.length;
        }

        wrapper.querySelectorAll(":scope > [data-collection-slider-clone]").forEach(function (clone) {
            clone.remove();
        });

        const targetSlideCount = Math.ceil(6 / slides.length) * slides.length;
        let totalSlides = slides.length;
        let sourceIndex = 0;

        while (totalSlides < targetSlideCount) {
            const clone = slides[sourceIndex % slides.length].cloneNode(true);
            clone.setAttribute("data-collection-slider-clone", "true");
            clone.removeAttribute("id");
            clone.removeAttribute("data-shopify-editor-block");
            clone.querySelectorAll("[id], [data-shopify-editor-block]").forEach(function (element) {
                element.removeAttribute("id");
                element.removeAttribute("data-shopify-editor-block");
            });
            wrapper.appendChild(clone);
            totalSlides += 1;
            sourceIndex += 1;
        }

        return totalSlides;
    }

    function initCollectionSliders(root) {
        const scope = root || document;

        scope.querySelectorAll("[data-collection-slider]").forEach(function (section) {
            const slider = section.querySelector(".collection-slider__swiper");
            if (!slider || slider.swiper) return;

            const slideCount = ensureEnoughLoopSlides(slider);
            if (slideCount > 1) {
                new Swiper(slider, {
                    slidesPerView: "auto",
                    centeredSlides: true,
                    loop: true,
                    loopAdditionalSlides: 0,
                    spaceBetween: 0,
                    speed: reducedMotionQuery.matches ? 0 : 700,
                    grabCursor: true,
                    slideToClickedSlide: false,
                    watchSlidesProgress: true,
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                        pageUpDown: false,
                    },
                    autoplay: reducedMotionQuery.matches
                        ? false
                        : {
                              delay: 5000,
                              disableOnInteraction: false,
                              pauseOnMouseEnter: false,
                          },
                    on: {
                        click: function (swiper, event) {
                            const clickedSlide = swiper.clickedSlide;
                            if (!clickedSlide || event.target.closest("a, button")) return;

                            if (clickedSlide.classList.contains("swiper-slide-next")) {
                                swiper.slideNext();
                            } else if (clickedSlide.classList.contains("swiper-slide-prev")) {
                                swiper.slidePrev();
                            }
                        },
                    },
                });
            }

            revealCollectionSlider(section);
        });

        updateImageZoom();

        if (!zoomEventsBound) {
            window.addEventListener("scroll", requestImageZoomUpdate, { passive: true });
            window.addEventListener("resize", requestImageZoomUpdate);
            reducedMotionQuery.addEventListener("change", updateImageZoom);
            zoomEventsBound = true;
        }
    }

    document.addEventListener("DOMContentLoaded", function () {
        initCollectionSliders(document);
    });

    document.addEventListener("shopify:section:load", function (event) {
        initCollectionSliders(event.target);
    });

    document.addEventListener("shopify:block:select", function (event) {
        const slide = event.target.closest(".collection-slider__slide");
        const slider = slide ? slide.closest(".collection-slider__swiper") : null;
        if (!slide || !slider || !slider.swiper) return;

        const realIndex = Number(slide.getAttribute("data-swiper-slide-index"));
        if (Number.isInteger(realIndex)) {
            slider.swiper.slideToLoop(realIndex);
        }
    });
})();
